import {
  ActivityTemplateApi,
  AuthApi,
  B2cApi,
  CaptureApi,
  ChargeApi,
  ChatApi,
  ConsentApi,
  ConsentRequestApi,
  CustomErrorControllerApi,
  EmailApi,
  EventsApi,
  FileApi,
  GroupApi,
  HouseApi,
  MeApi,
  NodeApi,
  NodeV2Api,
  NotificationApi,
  PetApi,
  PetImageApi,
  PublicConsentApi,
  ReportApi,
  ReportTemplateApi,
  ScheduleApi,
  ZoneApi,
} from "@careforu-tailody/tailody-core-api";

import {
  AnomalyApi,
  ConditionApi,
  MetricsApi,
  NodeApi as NodeMetricsApi,
} from "@careforu-tailody/metrics-service-api";
import { getApiClient, getConfig } from "@api/index.ts";

export interface ApiInstances {
    activityTemplate: ActivityTemplateApi;
    auth: AuthApi;
    b2c: B2cApi;
    capture: CaptureApi;
    charge: ChargeApi;
    chat: ChatApi;
    consent: ConsentApi;
    consentRequest: ConsentRequestApi;
    customErrorController: CustomErrorControllerApi;
    email: EmailApi;
    events: EventsApi;
    file: FileApi;
    group: GroupApi;
    house: HouseApi;
    me: MeApi;
    node: NodeApi;
    nodeV2: NodeV2Api;
    notification: NotificationApi;
    pet: PetApi;
    petImage: PetImageApi;
    publicConsent: PublicConsentApi;
    report: ReportApi;
    reportTemplate: ReportTemplateApi;
    schedule: ScheduleApi;
    zone: ZoneApi;
    anomaly: AnomalyApi;
    condition: ConditionApi;
    metrics: MetricsApi;
    nodeMetrics: NodeMetricsApi;
}

function createApiInstances(): ApiInstances {
  const axiosInstance = getApiClient().getAxiosInstance();
  const config = getConfig();

  return {
    activityTemplate: new ActivityTemplateApi(undefined, config.baseUrl, axiosInstance),
    auth: new AuthApi(undefined, config.baseUrl, axiosInstance),
    b2c: new B2cApi(undefined, config.baseUrl, axiosInstance),
    capture: new CaptureApi(undefined, config.baseUrl, axiosInstance),
    charge: new ChargeApi(undefined, config.baseUrl, axiosInstance),
    chat: new ChatApi(undefined, config.baseUrl, axiosInstance),
    consent: new ConsentApi(undefined, config.baseUrl, axiosInstance),
    consentRequest: new ConsentRequestApi(undefined, config.baseUrl, axiosInstance),
    customErrorController: new CustomErrorControllerApi(undefined, config.baseUrl, axiosInstance),
    email: new EmailApi(undefined, config.baseUrl, axiosInstance),
    events: new EventsApi(undefined, config.baseUrl, axiosInstance),
    file: new FileApi(undefined, config.baseUrl, axiosInstance),
    group: new GroupApi(undefined, config.baseUrl, axiosInstance),
    house: new HouseApi(undefined, config.baseUrl, axiosInstance),
    me: new MeApi(undefined, config.baseUrl, axiosInstance),
    node: new NodeApi(undefined, config.baseUrl, axiosInstance),
    nodeV2: new NodeV2Api(undefined, config.baseUrl, axiosInstance),
    notification: new NotificationApi(undefined, config.baseUrl, axiosInstance),
    pet: new PetApi(undefined, config.baseUrl, axiosInstance),
    petImage: new PetImageApi(undefined, config.baseUrl, axiosInstance),
    publicConsent: new PublicConsentApi(undefined, config.baseUrl, axiosInstance),
    report: new ReportApi(undefined, config.baseUrl, axiosInstance),
    reportTemplate: new ReportTemplateApi(undefined, config.baseUrl, axiosInstance),
    schedule: new ScheduleApi(undefined, config.baseUrl, axiosInstance),
    zone: new ZoneApi(undefined, config.baseUrl, axiosInstance),
    anomaly: new AnomalyApi(undefined, config.baseUrl, axiosInstance),
    condition: new ConditionApi(undefined, config.baseUrl, axiosInstance),
    metrics: new MetricsApi(undefined, config.baseUrl, axiosInstance),
    nodeMetrics: new NodeMetricsApi(undefined, config.baseUrl, axiosInstance),
  };
}

let _apiClientManager: { apis: ApiInstances } | null = null;

export const apiClientManager = {
  get apis(): ApiInstances {
    if (!_apiClientManager) {
      _apiClientManager = { apis: createApiInstances() };
    }
    return _apiClientManager.apis;
  },
};
